import { render, staticRenderFns } from "./MainResearch.vue?vue&type=template&id=5e4f9c46&scoped=true&"
import script from "./MainResearch.vue?vue&type=script&lang=js&"
export * from "./MainResearch.vue?vue&type=script&lang=js&"
import style0 from "./MainResearch.vue?vue&type=style&index=0&id=5e4f9c46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4f9c46",
  null
  
)

export default component.exports